import { Injectable } from '@angular/core';
import {from, mergeMap, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ChunkUploadService {

  constructor(private http: HttpClient) {}

  // Function to split the file into chunks
  splitFileIntoChunks(file: File, chunkSize: number): Blob[] {
    const totalChunks = Math.ceil(file.size / chunkSize);
    let currentChunk = 0;
    const chunks: Blob[] = [];

    while (currentChunk < totalChunks) {
      const start = currentChunk * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      chunks.push(file.slice(start, end));
      currentChunk++;
    }

    return chunks;
  }

  // Function to upload the file in chunks
  uploadFile(file: File, blogId: number | null, chunkSize: number, uuid = ''): Observable<any> {
    const chunks = this.splitFileIntoChunks(file, chunkSize);
    const totalChunks = chunks.length;
    const fileIdentifier = this.generateFileIdentifier();
    return new Observable<any>((observer) => {
      let chunkNumber = 0;

      // tslint:disable-next-line:no-shadowed-variable
      const uploadChunk = (chunk: Blob, chunkNumber: number) => {
        const formData = new FormData();
        formData.append('chunk', chunk, file.name);
        formData.append('chunk_number', (chunkNumber + 1).toString());
        formData.append('total_chunks', totalChunks.toString());
        formData.append('file_identifier', fileIdentifier);
        formData.append('filename', file.name);
        if (blogId) {
          formData.append('blog_id', blogId.toString());
        }
        if (uuid) {
          formData.append('uuid', uuid);
        }

        return uuid ? this.http.post('admin/upload/chunkSection', formData) : this.http.post('admin/upload/chunk', formData);
      };

      const uploadNextChunk = () => {
        if (chunkNumber < totalChunks) {
          const chunk = chunks[chunkNumber];
          uploadChunk(chunk, chunkNumber).subscribe({
            next: (res) => {
              chunkNumber++;
              const progress = Math.round((chunkNumber / totalChunks) * 100);
              observer.next({progress, fileName: res});
              uploadNextChunk();
            },
            error: (err) => {
              observer.error(`Error uploading chunk ${chunkNumber + 1}: ${err}`);
            }
          });
        } else {
          observer.complete();
        }
      };
      uploadNextChunk();
    });
  }
  generateFileIdentifier(): string {
    return 'file-' + Date.now();
  }
}
